export const MANATEE_CARE_PROVIDER = "Building Brave Kids";
export const CPT_CODE_INTAKE_60_MIN = "90791";
import config from "../config/env";

export const IS_PROD = process.env.NODE_ENV === "production";
export const IS_DEV = process.env.NODE_ENV === "development";
export const IS_STAGING = config.env.REACT_APP_ENV === "staging";

export const EVERNORTH_TRIGGER_PARAM = "utm_source";
export const EVERNORTH_TRIGGER_VALUE = "evernorth";

export const CONSULT_APPT_TYPE_ID = config.env.REACT_APP_CONSULT_APPT_TYPE_ID;
export const PARENT_NAVIGATION_APPT_TYPE_ID = config.env.REACT_APP_PARENT_NAVIGATION_APPT_TYPE_ID;

export const CONSULT_TYPEFORM_ID = config.env.REACT_APP_CONSULT_TYPE_FORM_ID;
export const EVERNORTH_TYPEFORM_ID = config.env.REACT_APP_EVERNORTH_TYPE_FORM_ID;
